import { Route } from '@angular/router';
import { PortalAuthFeatureShellComponent } from './portal-auth-feature-shell.component';

export const routes: Route[] = [
  {
    path: '',
    component: PortalAuthFeatureShellComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('@portal-front/portal-auth-feature-login-page').then((m) => m.LoginPageComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('@portal-front/portal-auth-feature-forgot-password-page').then((m) => m.ForgotPasswordPageComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('@portal-front/portal-auth-feature-register-page').then((m) => m.RegisterPageComponent),
      },
    ],
  },
];
